import { ReactNode, useMemo } from 'react';
import { ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { Provider as OvermindProvider } from 'overmind-react';
import { createOvermind } from 'overmind';
import { config as overmindConfig } from '#store/overmind';
import { LoginNotificationDialogProvider } from '#modules/dialog-login-notification/DialogLoginNotification';
import { RentNotificationDialogProvider } from '#modules/dialog-rent-notification/DialogRentNotification';
import { ParentalControlProvider } from '#modules/player/ParentalControl';
import { useRouter } from 'next/router';
import { useApollo } from '#hooks/useApollo';

type Props = {
  children: ReactNode;
  apolloState?: NormalizedCacheObject;
};

// TODO: FORCE NEW overmind on story restart
// MSWMockCommonProviders -> use createOvermind and MSWMockWrapper together
const ApplicationProviders = ({ children, apolloState }: Props) => {
  const { asPath: path } = useRouter();

  const apolloClient = useApollo({
    initialState: apolloState,
    context: { resolvedUrl: path },
  });

  const overmindStore = useMemo(() => {
    return createOvermind(overmindConfig);
  }, []);

  return (
    <ApolloProvider client={apolloClient}>
      <OvermindProvider value={overmindStore}>
        <LoginNotificationDialogProvider>
          <RentNotificationDialogProvider>
            <ParentalControlProvider>{children}</ParentalControlProvider>
          </RentNotificationDialogProvider>
        </LoginNotificationDialogProvider>
      </OvermindProvider>
    </ApolloProvider>
  );
};

export default ApplicationProviders;
